import React from 'react'
import PropTypes from 'prop-types'
import formatMessage from 'format-message'
import { IosSwitch } from '@CommonComponents'

class ReaderToolbarNarrateSwitch extends React.Component {
  static propTypes = {
    isModal: PropTypes.bool.isRequired,
  }

  narrateElem = null
  state = {
    counter: 0,
  }

  render() {
    if (!this.narrateElem) {
      return null // no element means narration not enabled in this course (see web.html)
    }

    return (
      <div className="booktools_item">
        <div className="booktools_item_title">
          <label className="d-flex">
            <span className="align-self-center mr-4">
              {formatMessage('Narration')}
            </span>
            <IosSwitch
              onChange={evt => {
                this.setPlayerVisible(evt.target.checked)
              }}
              checked={this.playerVisible}
              disabled={!this.narrateElem.isAppReady}
              scale="0.7"
            />
          </label>
        </div>
        <div className="clearfix" />
      </div>
    )
  }

  componentDidMount() {
    this.narrateElem = document.querySelector('vapp-narrate')
    if (this.narrateElem) {
      // sync our UI switch after any app/player event. for example, if user closes the player
      // via player's close button, we need to render to update our switch to match.
      this.narrateElem.addEventListener('vapp-ready', this.triggerRender)
      this.narrateElem.addEventListener('vapp-shutdown', this.triggerRender)
      this.narrateElem.addEventListener('vapp-show-player', this.triggerRender)
      this.narrateElem.addEventListener('vapp-hide-player', this.triggerRender)
    }
  }

  componentWillUnmount() {
    if (this.narrateElem) {
      this.narrateElem.removeEventListener('vapp-ready', this.triggerRender)
      this.narrateElem.removeEventListener('vapp-shutdown', this.triggerRender)
      this.narrateElem.removeEventListener(
        'vapp-show-player',
        this.triggerRender
      )
      this.narrateElem.removeEventListener(
        'vapp-hide-player',
        this.triggerRender
      )
      this.narrateElem = null
    }
  }

  /** Imperatively triggers a render to update the switch UI */
  triggerRender = () => {
    this.setState(state => ({
      counter: state.counter + 1,
    }))
  }

  /** Toggles the player visibility */
  setPlayerVisible(show) {
    if (this.narrateElem) {
      if (show) {
        this.narrateElem.setAttribute('show', 'show')
      } else {
        this.narrateElem.removeAttribute('show')
      }
      this.triggerRender()
    }
  }

  /** Returns whether the player is visible */
  get playerVisible() {
    return !!(
      this.narrateElem &&
      this.narrateElem.provider &&
      this.narrateElem.provider.playerVisible
    )
  }
}

export default ReaderToolbarNarrateSwitch
